import { render, staticRenderFns } from "./AgentPlan.vue?vue&type=template&id=70c4e8cc&"
import script from "./AgentPlan.vue?vue&type=script&lang=js&"
export * from "./AgentPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports